(() => {
    const currentUrl = new URL(window.location);
    const currentHostname = currentUrl.hostname;
    const alternateUrls = Array.from(document.querySelectorAll('link[rel="alternate"][hreflang]')).reduce((acc, entry) => {
        const alternateUrl = new URL(entry.href);
        const alternateHostname = alternateUrl.hostname;

        acc[alternateHostname] = entry.href;

        return acc;
    }, {});

    let previousHostname = '';
    if (document.referrer) {
        const previousUrl = new URL(document.referrer);

        previousHostname = previousUrl.hostname;
    }

    if (previousHostname !== '' && previousHostname !== currentHostname) {
        window.Cookies.set('swinger.preferredhostname', currentHostname);
    } else {
        const preferredHostname = window.Cookies.get('swinger.preferredhostname');

        if (currentHostname !== preferredHostname && alternateUrls[preferredHostname]) {
            const targetUrl = alternateUrls[preferredHostname];
            const searchQuery = window.location.search;

            window.location.href = targetUrl.indexOf('?') === -1 ? `${targetUrl}${searchQuery}` : targetUrl;
        }
    }
})();
